document.addEventListener('DOMContentLoaded', function () {
  const modals = document.querySelectorAll('.ugc-video-modal');
  const playButtons = document.querySelectorAll('.ugc-video_wrapper');
  const closeButtons = document.querySelectorAll('.ugc-video-modal_close');

  // Helper function to detect if the browser is mobile
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);


  // Add event listeners for each modal
  playButtons.forEach(function (playButton, index) {
    const modal = modals[index];
    const modalVideo = modal.querySelector('video');
    const closeButton = closeButtons[index];

    // Function to fully reset the video element
    const resetVideo = () => {
      modalVideo.pause();
      modalVideo.currentTime = 0; // Reset video to the start
      modalVideo.muted = true;
      modalVideo.load(); // Reload the video source
    };

    // Function to close the modal and reset the video
    const closeModal = () => {
      modal.style.display = 'none';
      resetVideo();
    };

    // Function to play video on mobile by creating a temporary video element
    const playMobileVideo = (videoSrc) => {
      // Create a temporary video element
      const tempVideo = document.createElement('video');
      tempVideo.src = videoSrc;
      tempVideo.controls = true;
      tempVideo.autoplay = true;
      tempVideo.style.width = '100%'; // You can adjust width as needed
      document.body.appendChild(tempVideo);

      // Play the video and remove it once it's done
      tempVideo.addEventListener('ended', function () {
        tempVideo.remove(); // Remove the video from the DOM once it ends
      });

      tempVideo.addEventListener('pause', function () {
        tempVideo.remove(); // Optionally remove if paused
      });
    };

    // Play button click event
    playButton.addEventListener('click', function () {
      if (isIOS) {
        // On mobile, play the video outside the modal
        const videoSrc = modalVideo.querySelector('source').src; // Get video source
        playMobileVideo(videoSrc);
      } else {
        // On desktop, show the modal and play the video inside it
        modal.style.display = 'flex';
        modalVideo.play();
        modalVideo.muted = false;
      }
    });

    // Close button click event to close the modal (desktop only)
    closeButton.addEventListener('click', closeModal);

    // Close modal when clicking outside the video (desktop only)
    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    // Close modal when the video ends (desktop only)
    modalVideo.addEventListener('ended', closeModal);
  });
});
